import { MapPin } from "lucide-react";
import type { CrmAddress } from "@/lib/api/crm/masters";
import { TagList } from "./TagList";

function addressLines(address: CrmAddress): string[] {
  const stateAndZip = [address.state, address.zipcode].filter(Boolean).join(" ");
  const cityLine = [address.city, stateAndZip].filter(Boolean).join(", ");
  const gpsLine = address.gps_latitude || address.gps_longitude
    ? `GPS: (${address.gps_latitude ?? "-"},${address.gps_longitude ?? "-"})`
    : null;
  return [address.address_line_one, address.address_line_two, cityLine, address.county, address.country, gpsLine]
    .filter((line): line is string => Boolean(line));
}

export function AddressList({ addresses }: { addresses: CrmAddress[] }) {
  if (addresses.length === 0) {
    return <p className="text-sm text-gray-400">No addresses yet</p>;
  }

  return (
    <ul className="space-y-3">
      {addresses.map((address) => {
        const lines = addressLines(address);
        return (
          <li key={address.id} className="flex items-start gap-3" data-testid={`crm-address-${address.id}`}>
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-gray-500 ring-1 ring-gray-200">
              <MapPin className="h-4 w-4" />
            </span>
            <div className="min-w-0 flex-1 text-sm">
              {address.label && <p className="font-medium text-gray-900">{address.label}</p>}
              {lines.length > 0 ? (
                lines.map((line, index) => (
                  <p key={index} className="text-gray-700">{line}</p>
                ))
              ) : (
                <p className="text-gray-400">No address details</p>
              )}
              <TagList tags={address.tags} />
            </div>
          </li>
        );
      })}
    </ul>
  );
}
